import { useSelector } from 'react-redux'
import props from '../../../../redux/props'

const Success = () => {
  const t = useSelector((s) => s[props.TRANSLATION])

  return (
    <div className="min-h-[60vh] flex flex-col gap-5 items-center justify-center">
      <div className="font-bold text-xl md:text-2xl text-center">{t.survey.answer.submit.success}</div>
    </div>
  )
}

export default Success
